import { render, staticRenderFns } from "./PropertyContactListTable.vue?vue&type=template&id=c1068b94&"
import script from "./PropertyContactListTable.vue?vue&type=script&lang=js&"
export * from "./PropertyContactListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports